export const getRandomizedLoadingTitle = (): string => {
  const titleLoadingPlaceholders: string[] = [
    window.i18next.t('pmwjs_sm_publishing_title_loading_1'),
    window.i18next.t('pmwjs_sm_publishing_title_loading_2'),
    window.i18next.t('pmwjs_sm_publishing_title_loading_3'),
    window.i18next.t('pmwjs_sm_publishing_title_loading_4'),
    window.i18next.t('pmwjs_sm_publishing_title_loading_5'),
  ];

  const randomNumber = Math.floor(Math.random() * 5);
  return titleLoadingPlaceholders[randomNumber];
};
